import { Router as PreactRouter, Route, route } from 'preact-router'

import paths from '~/enums/paths'
import {
	CryptPage,
	ErrorPage,
	Experiment,
	HomePage,
	NotFoundPage,
	SandboxPage,
	WorkPage,
} from '~/pages'

// Redirect the legacy /projects path to the new /work landing.
function ProjectsRedirect() {
	route(paths.work, true)
	return null
}

export default function Router() {
	return (
		<PreactRouter>
			<Route path={paths.root} component={HomePage} />
			<Route path={paths.crypt} component={CryptPage} />
			<Route path={paths.work} component={WorkPage} />
			<Route path="/work/:slug" component={WorkPage} />
			<Route path={paths.projects} component={ProjectsRedirect} />
			<Route path={paths.sandbox} component={SandboxPage} />
			<Route path="/sandbox/:slug" component={Experiment} />
			<Route path={paths.notFound} component={NotFoundPage} />
			<Route path={paths.error} component={ErrorPage} />
			<Route component={NotFoundPage} default />
		</PreactRouter>
	)
}
